// to be used during development only ofc
export const inspect = (consoleMock = console) => (oldState, newState, path = '', name = 'anonymous action') => {
  consoleMock.groupCollapsed(`%c ${name} %c(store path: %c${path}%c)`, 'color: #72bdf9', 'color: #333333', 'color: #D06D00', 'color: #333333')
  consoleMock.log('%c old state', 'color: #E7040F', oldState)
  consoleMock.log('%c new state', 'color: #19A974', newState)
  consoleMock.groupEnd()
}

export default inspect()
